import { WorkGroup, WorkGroupDetailModel } from "@teamprevent/common/workGroup/model";

import componentRoutes from "./components/componentRoutes";
import { Base } from "./components/Base";
import { WorkGroupState } from "./model";
import { workGroups as reducer } from "./reducer";
import { routes } from "./routes";
import { loadWorkGroups, loadWorkGroupsSuccess } from "./actions";
import * as selectors from "./selectors";
import { CoreDetails } from "./components/details/CoreDetails";
import { workGroupApi } from "./workGroupApi";

export {
    WorkGroup,
    WorkGroupDetailModel,
    componentRoutes,
    reducer,
    WorkGroupState,
    routes,
    loadWorkGroups,
    loadWorkGroupsSuccess,
    selectors,
    Base,
    CoreDetails,
    workGroupApi
};
